import React, { useMemo } from "react";
import type { CarouselProps } from "../types";

const sizeMap = (forceFade = false) => ({
  "light": `${ forceFade ? "cui-w-4" : "cui-w-0" } small-mobile:cui-w-4 md:cui-w-8`,
  "dark": `${ forceFade ? "cui-w-4" : "cui-w-0" } small-mobile:cui-w-2 md:cui-w-4`
});

const fadeColorMap = {
"bg-base": "cui-to-bg-base",
"bg-default": "cui-to-bg-default",
"bg-layer-one": "cui-to-bg-layer-one",
"bg-layer-three": "cui-to-bg-layer-three",
"bg-layer-two": "cui-to-bg-layer-two",
"bg-primary": "cui-to-bg-primary",
"bg-primary-minimal": "cui-to-bg-primary-minimal",
"bg-primary-strong": "cui-to-bg-primary-strong",
"bg-transparent": "cui-to-bg-transparent"
}

export const GradientOverlay = ({
  className,
  slot,
  flip,
  type = "light",
  visible = true,
  forceFade,
  fadeColor = "bg-default",
  topOffset = 0,
  zIndex = 40,
  left,
  right
}: {
  type: CarouselProps["fadeType"];
  visible: Boolean;
  className?: string;
  slot?: string;
  flip?: boolean;
  forceFade?: boolean;
  topOffset?: number;
  zIndex?: number;
  left?: number;
  right?: number;
  fadeColor?: string;
}) => {

  const colors = {
    "light": `cui-from-neutrals-transparent ${fadeColor in fadeColorMap ? fadeColorMap[fadeColor] : "cui-to-bg-default"}`,
    "dark": "" //`cui-from-neutrals-transparent cui-to-fg-global-black ${visible ? "cui-opacity-25" : ""}`
  }

  const fadeType = type in colors ? colors[type] : colors["light"];
  const _sizeMap = sizeMap(forceFade);
  const size = type in _sizeMap ? _sizeMap[type] : _sizeMap["light"];
  const isDark = type === "dark";

  const darkLeft = typeof left !== "undefined" && isDark ?  left - 12 : -12;
  const _style = useMemo(()=>{
    if (!visible) return { topOffset, zIndex, left, right };
    return isDark ? {
      boxShadow: "0px 12px 12px 0px rgba(0, 0, 0, 0.07)",
      width: 12,
      top: topOffset,
      zIndex,
      left: isDark ? darkLeft : left,
      right
    } : {
      top: topOffset,
      zIndex,
      left,
      right
    }
  },[type, visible, left, right, zIndex])
  return (
    <div
      slot={slot}
      className={`cui-absolute ${flip ? "cui-bg-gradient-to-r" : "cui-bg-gradient-to-l"} ${fadeType} cui-h-full ${size} cui-transition-opacity cui-duration-200 cui-pointer-events-none ${className}`}
      style={_style}
    />
  )
};
